'use strict';

var index = require('../../../../aviary-tokens/dist/cjs/index.cjs');
var React = require('react');

const AviaryThemeContext = /*#__PURE__*/ React.createContext({
    setTheme: ()=>null,
    currentTheme: index.fullscriptWebLight.desktop1024,
    isDS3: false
});

exports.AviaryThemeContext = AviaryThemeContext;
//# sourceMappingURL=AviaryThemeContext.cjs.map
